export default __webpack_public_path__ + "static/media/hamburg-yellow.c871b646.png";